import React, { Component } from 'react';
import { ErrorBox } from '../components/ErrorBox.tsx';
import { NextButton } from '../components/NextButton.tsx';
import { PreviousButton } from '../components/PreviousButton.tsx';
import { LenderRow } from '../components/LenderRow.tsx';
import { SwitcherRateMonthSelect } from '../components/SwitcherRateMonthSelect.tsx';
import { SwitcherRateYearSelect } from '../components/SwitcherRateYearSelect.tsx';

interface IProps {
    gtmEvent(): void;
    prevStep(): void;
    nextStep(s: string): void;
    updateLead(props: any): void;
    title: any;
    subtitle?: any;
    currentswitcherratemonth?: string;
    currentBER?: string;
    currentswitcherrateyear?:string;
}

interface IState {
    hasError: boolean;
    errors?: string[];
    currentswitcherratemonth?: string;
    currentswitcherrateyear?:string;
    switcherrateval?:string;
}

export class SwitcherRates extends Component<IProps, IState> {
    constructor (props: IProps) {
        super(props);
        this.state = {hasError: false,switcherrateval:null};
    }

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    nextStep(response: string) {
        const errors:string[]=[];
        if((this.state.switcherrateval=="fixed")&&(!this.state.currentswitcherratemonth)){
            errors.push("Month is required");
        }
        if((this.state.switcherrateval=="fixed")&&(!this.state.currentswitcherrateyear)){
            errors.push("Year is required");
        }
        if (errors.length > 0) {
            this.setState({ hasError: true, errors });
            return;
        }
        this.setState({ hasError: false, errors: [] });
        this.props.updateLead({switcherrate: response});
        this.props.nextStep(response);
    }
    
    render() {
        return (
            <header className="App-header">
                <h1 className='l'>{this.props.title}</h1>
                {this.props.subtitle && <p>{this.props.subtitle}</p>}
                <br/>
                    <div className='wrapper'>
                        <div className='row'>
                        <div className='column2 flex-end'>
                            {/* <div className='boxty small' onClick={() => this.nextStep('yes')}> */}
                            <div className={`boxty small ${this.state.switcherrateval==='fixed'?'selected':''}`} onClick={() => {this.setState({switcherrateval:'fixed'})}}>
                                <div><h2 className='btn'>Fixed Rate</h2></div>
                            </div>
                        </div>


                        <div className='column2 flex-start'>
                            {/* <div className='boxty small' onClick={() => this.nextStep('yes')}> */}
                            <div className={`boxty small ${this.state.switcherrateval==='variable'?'selected':''}`} onClick={() => {this.setState({switcherrateval:'variable'});this.props.nextStep('variable')}}>
                                <div><h2 className='btn'>Variable Rate</h2></div>
                            </div>
                        </div>

                        
                        </div>
                    </div>
                <br/>
                
                {(this.state.switcherrateval==='fixed') && (<>
                <label htmlFor='consent'>What is the <b>approximate expiry</b> date of your fixed term mortgage?</label> 
                </>)}
                <div className='wrapper'>
                    {(this.state.switcherrateval==='fixed') && (<>
                    <div className='row'>
                        <div className='column2 justify-e'>
                            <div className='justify-c' style={{maxWidth: 390}}>
                                <SwitcherRateMonthSelect
                                    key='lenders'
                                    classes={this.state.hasError && !this.state.currentswitcherratemonth ? "e" : ""}
                                    
                                    selectedswitcherratemonth={this.props.currentswitcherratemonth}
                                    onChange={(e) => { this.setState({currentswitcherratemonth: e.target.value}); this.props.updateLead({currentswitcherratemonth:e.target.value}); }} />
                            </div>
                        </div>
                        <div className='column2 justify-s'>
                            <div className='justify-c' style={{maxWidth: 390}}>
                                <SwitcherRateYearSelect
                                    key='ber'
                                    classes={this.state.hasError && !this.state.currentswitcherrateyear ? "e" : ""}
                                    
                                    selectedswitcherrateyear={this.props.currentBER}
                                    onChange={(e) => {this.setState({currentswitcherrateyear: e.target.value}); this.props.updateLead({currentswitcherrateyear:e.target.value})}} />
                            </div>
                        </div>
                    </div></>)}
                    {this.state.hasError &&
                        <ErrorBox errors={this.state.errors!} />
                    }
                    <div className='row'>
                        <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                            <NextButton onClick={() => this.nextStep(this.state.switcherrateval==='variable'?this.state.switcherrateval:this.state.currentswitcherrateyear+'-'+this.state.currentswitcherratemonth+'-01')} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow />
                    </div>
                </div>

            </header>
        );
    }
}
